import React from 'react';
import {Checkbox} from '@carbon/react';
import ComplianceIndicator from '../compliance-indicator';
import {SpecialtyScore} from '../hooks/use-specialty-filter';

type Props = {
    specialty: SpecialtyScore;
    isSelected: boolean;
    isDisabled: boolean;
    color: string;
    onToggle: (code: string) => void;
    testId: string;
};

export default function SpecialtyListItem({
    specialty,
    isSelected,
    isDisabled,
    color,
    onToggle,
    testId,
}: Props) {
    return (
        <li
            className={`specialty-item ${isDisabled ? 'disabled' : ''}`}
            data-testid={testId}
        >
            <div className="specialty-content">
                <Checkbox
                    id={`specialty-${specialty.specialtyCode}`}
                    checked={isSelected}
                    onChange={() => onToggle(specialty.specialtyCode)}
                    labelText=""
                    disabled={isDisabled}
                />
                <span className="specialty-name" title={specialty.name}>
                    {specialty.name}
                </span>
                <div
                    className="specialty-color-indicator"
                    style={{
                        backgroundColor: isSelected ? color : 'transparent'
                    }}
                />
                {specialty.compliance !== undefined && (
                    <div className="specialty-compliance">
                        <ComplianceIndicator passed={specialty.compliance} showText={true} />
                    </div>
                )}
            </div>
        </li>
    );
}
